import { render, staticRenderFns } from "./Box2.vue?vue&type=template&id=b4883ab8"
import script from "./Box2.vue?vue&type=script&lang=js"
export * from "./Box2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports